export interface ITemplateColumnInfo {
  id: number;
  name: string;
  tableName: string;
  columnName: string;
  regDt: string;
  modDt: string;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const isTemplateColumnInfo = (value: unknown): value is ITemplateColumnInfo => {
  if (!isRecord(value)) return false;

  return (
    typeof value.id === "number" &&
    typeof value.name === "string" &&
    typeof value.tableName === "string" &&
    typeof value.columnName === "string"
  );
};

export const normalizeTemplateColumnInfoList = (
  responseData: unknown
): ITemplateColumnInfo[] => {
  if (Array.isArray(responseData)) {
    return responseData.filter(isTemplateColumnInfo);
  }

  if (!isRecord(responseData)) {
    return [];
  }

  const { data } = responseData;

  if (Array.isArray(data)) {
    return data.filter(isTemplateColumnInfo);
  }

  if (!isRecord(data)) {
    return [];
  }

  if (Array.isArray(data.list)) {
    return data.list.filter(isTemplateColumnInfo);
  }

  return [];
};
